<template>
  <div class="py-5 text-center abbv-wrapper">
    <div class="container">
      <div v-html="$t('Footer.legalrules')" class="abbrev-terms text-center"></div>
    </div>
  </div>
  <footer class="py-4">
    <div class="container-fluid px-4 py-0">
      <div class="row align-items-center">
        <div class="col-md-9 text-center text-md-start">
          <ul class="list-inline" id="footer-nav" data-gtm-menu-type="footer">
            <li class="list-inline-item" data-gtm-menu="Do Not Sell My Personal Information/Cookie Settings">
              <a class="ot-sdk-show-settings" href="javascript:void(0);" onclick="Optanon.ToggleInfoDisplay()">Do Not
                Sell My Personal Information/Cookie Settings</a>
            </li>
            <li class="list-inline-item" data-gtm-menu="Cookie Policy"><a rel="noopener noreferrer"
                href="https://www.suntoryglobalspirits.com/en/cookie-policy" target="_blank">Cookie Policy</a></li>
            <li class="list-inline-item" data-gtm-menu="Privacy Policy"><a rel="noopener noreferrer"
                href="https://www.suntoryglobalspirits.com/en/privacy-policy" target="_blank">Privacy Policy</a></li>
            <li class="list-inline-item" data-gtm-menu="Suntory Marketing Code"><a rel="noopener noreferrer"
                href="https://www.suntoryglobalspirits.com/sites/default/files/2024-04/bsi-marketing-code-of-practice.pdf"
                target="_blank" auto-tracked="true">Suntory Marketing Code </a></li>
            <li class="list-inline-item" data-gtm-menu="Terms and Conditions"><a rel="noopener noreferrer"
                href="https://www.suntoryglobalspirits.com/en/terms-and-conditions" target="_blank">Terms and
                Conditions</a></li>
            <li class="list-inline-item" data-gtm-menu="Supply Chain Transparency"><a rel="noopener noreferrer"
                href="https://www.suntoryglobalspirits.com/supply-chain-transparency" target="_blank">Supply Chain
                Transparency</a></li>
            <li class="list-inline-item" data-gtm-menu="Drink Smart Website"><a rel="noopener noreferrer"
                href="http://drinksmart.com/" target="_blank">Drink Smart Website</a></li>
            <li class="list-inline-item" data-gtm-menu="Accessibility Statement"><a rel="noopener noreferrer"
                href="https://www.suntoryglobalspirits.com/accessibility-statement" target="_blank">Accessibility
                Statement</a></li>
          </ul>
          <p class="mt-4 mt-sm-1 mb-0 copyright-text">© {{ new Date().getFullYear() }} <span
              v-html="$t('Footer.copyrighttext')"></span></p>
        </div>
        <div class="col-md-3 text-center text-md-end mt-3 mt-md-0 pe-5">
          <div class="footer-social-nav">
            <ul class="list-inline m-0">
              <li class="footer-links me-2 list-inline-item text-uppercase">{{ $t('Footer.FollowUs') }}</li>
              <li class="list-inline-item">
                <a href="https://www.facebook.com/JimBeam" class="fb-link social-icon" title="facebook" target="_blank"
                  aria-label="Facebook (opens in a new tab)" data-gtm-elem="share" data-gtm-social-network="Facebook"
                  data-gtm-url="https://www.facebook.com/JimBeam">
                  <i class="fab fa-facebook"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://www.instagram.com/jimbeamofficial" class="ig-link social-icon" title="instagram"
                  target="_blank" aria-label="Instagram (opens in a new tab)" data-gtm-elem="share"
                  data-gtm-social-network="Instagram" data-gtm-url="https://www.instagram.com/jimbeamofficial">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://www.youtube.com/jimbeam" class="yt-link social-icon" title="youtube" target="_blank"
                  aria-label="YouTube (opens in a new tab)" data-gtm-elem="share" data-gtm-social-network="YouTube"
                  data-gtm-url="https://www.youtube.com/jimbeam">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  /* mounted() {
     // // Dynamically fetch the translated modelHash
     const modelHash = this.$t('YounetmodelHash');
     const modelImgurl = this.$t('YounetmodelIMg');
     const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}&bottom=90`;
 
     // // Dynamically create the script element
     const script = document.createElement('script');
     script.type = 'module';
     script.src = scriptUrl;
 
     // // Append the script to the body
     document.body.appendChild(script);
   },*/
};
</script>